import React, { Component } from "react";
import { Popover, Icon } from "@mui/material";
import { ChromePicker } from "react-color";
import styled from "styled-components";

const ColorChitContainerDiv = styled.div`
    position: relative;
    width: 32px;
    height: 32px;
    float: left;
    display: inline-block;
    border-radius: 50%;
    background: ${props => props.previewBackground};
    .material-icons {
        opacity: 0;
        position: absolute;
        top: -4px;
        right: -4px;
        font-size: 16px;
        border-radius: 50%;
        background: white;
        cursor: pointer;
    }
    &:hover {
        .material-icons {
            opacity: 1
        }
    }
`;

const ColorChitDiv = styled.div`
    position: relative;
    height: 100%;
    width: 100%;
    border-radius: 50%;
    border: solid 1px #bbb;
`;

class ColorChit extends Component {
    constructor(props) {
        super(props);

        this.colorChitDivRef = React.createRef();

        this.state = {
            anchorEl: null,
            disableAlpha: props.disableAlpha, // Store disableAlpha state when picker opens
        };
    }

    componentDidUpdate = prevProps => {
        if (this.props.isNewColor) {
            this.openPicker();
        }
        // Only update disableAlpha state when picker is closed
        if (!this.state.anchorEl && prevProps.disableAlpha !== this.props.disableAlpha) {
            this.setState({ disableAlpha: this.props.disableAlpha });
        }
    }

    componentDidMount = () => {
        window.addEventListener("keydown", this.enterPressed);
    }

    componentWillUnmount = () => {
        window.removeEventListener("keydown", this.enterPressed);
    }

    enterPressed = event => {
        if (event.key === "Enter") {
            this.closePicker();
        }
    }

    handleChange = color => {
        // Ensure alpha is always a valid number between 0 and 1
        const alpha = color.rgb.a != null && !isNaN(color.rgb.a) ? Math.max(0, Math.min(1, color.rgb.a)) : 1;
        let rgba = `rgba(${color.rgb.r},${color.rgb.g},${color.rgb.b},${alpha})`;

        this.props.onChange && this.props.onChange(rgba);
    };

    openPicker = () => {
        // Store the current disableAlpha state when opening picker
        // This prevents the alpha UI from disappearing while picker is open
        this.setState({
            anchorEl: this.colorChitDivRef.current,
            disableAlpha: this.props.disableAlpha,
        });
    };

    closePicker = () => {
        this.setState({ anchorEl: null });
        // Update disableAlpha state after picker closes
        // This allows it to update for next time the picker opens
        setTimeout(() => {
            this.setState({ disableAlpha: this.props.disableAlpha });
        }, 0);
    };

    render() {
        const { color, onRemove } = this.props;

        return (
            <ColorChitContainerDiv style={this.props.style} data-color={color} previewBackground={this.props.previewBackground || "white"}>
                <ColorChitDiv
                    ref={this.colorChitDivRef}
                    onClick={this.openPicker}
                    style={{ backgroundColor: color || "#ccc" }}
                />
                {onRemove && <Icon onClick={onRemove}>cancel</Icon>}
                <Popover
                    open={Boolean(this.state.anchorEl)}
                    anchorEl={this.state.anchorEl}
                    disableEnforceFocus
                    disableRestoreFocus
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left"
                    }}
                    transformOrigin={{
                        vertical: "top",
                        horizontal: "left"
                    }}
                    onClose={this.closePicker}
                >
                    <ChromePicker
                        color={color}
                        style={{ boxShadow: "none" }}
                        disableAlpha={this.state.disableAlpha}
                        onChange={this.handleChange}
                        onChangeComplete={this.handleChange}
                    />
                </Popover>
            </ColorChitContainerDiv>
        );
    }
}

export default ColorChit;
